export default {
  validations: [],
  permissionError: null,
  isLoading: false,
  profile: {},
};
